<!--  平时习惯组件合并抽取  -->
<template>
  <div>
    <!-- input输入框定义 -->
    <el-form-item label="标题宽度">
      <el-input v-model="data.labelWidth"
                clearable
                placeholder="标题宽度"></el-input>
    </el-form-item>

    <!-- 自定义 monaco-editor 属性数据 -->
    <div class="el-form-item el-form-item--small el-form--label-top">
      <label class="el-form-item__label"
             style="padding: 0;">自定义属性：</label>
      <div class="el-form-item__content">
        <monaco-editor v-model="params"
                       height="300"
                       :keyIndex="data.prop"
                       :options="options"></monaco-editor>
      </div>
    </div>

    <!-- 自定义 monaco-editor 事件数据 -->
    <div class="el-form-item el-form-item--small el-form--label-top">
      <label class="el-form-item__label"
             style="padding: 0;">自定义事件：</label>
      <div class="el-form-item__content">
        <monaco-editor v-model="event"
                       height="300"
                       :keyIndex="data.prop"
                       :options="options"></monaco-editor>
      </div>
    </div>

    <!-- 设置 switch 是否只读 -->
    <el-form-item label="是否只读">
      <el-switch v-model="data.readonly"></el-switch>
    </el-form-item>

    <!-- 设置 switch 是否禁用 -->
    <el-form-item label="是否禁用">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>

    <!-- 设置 switch 是否是否可见 -->
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>

    <!-- 设置是否必填，正则表达式进行校验 -->
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
      <el-input v-if="data.required"
                v-model.lazy="data.pattern"
                placeholder="正则表达式"></el-input>
    </el-form-item>
  </div>
</template>
<script>

  //引入 monaca Editor
import MonacoEditor from '../utils/monaco-editor'

export default {
  //组件名称设置 config-custom
  name: 'config-custom',
  //将组件引入到本实例中
  components: { MonacoEditor },
  //引入vue data数据信息
  props: ['data'],
  data() {
    return {
      //拿到data的params
      params: this.data.params || {},
      //拿到data的event
      event: this.data.event || {},
      //占坑 预测为minimap的数据
      options: {
        //占坑
        minimap: {
          //是否自动
          enabled: false,
        },
      },
      //初始化校验器参数
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  methods: {
    //generate 生产规则
    generateRule() {
      const rules = [];
      //遍历规则器中所有规则，
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]){
          rules.push(this.validator[key])
        }
      })
      //将规则key放到data rules中
      this.data.rules = rules
    },
  },
  watch: {
    //监听 上面 传入的params
    'data.params'(val) {
      this.params = val || {}
    },
    //监听 上面 的event
    'data.event'(val) {
      this.event = val || {}
    },
    //监听 params ,上面params改变 ，修改data中的params的值
    params(val) {
      try {
        this.data.params = eval("(" + val + ")")
      } catch (e) {
        // console.error(e)
      }
    },
    //监听 params ,上面params改变 ，修改data中的event的值
    event(val) {
      try {
        this.data.event = eval("(" + val + ")")
      } catch (e) {
        // console.error(e)
      }
    },
    //监听 data中require值变化
    'data.required': function (val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null
      this.generateRule()
    },
    //监听 data中pattern变化，适配正则
    'data.pattern': function (val) {
      if (val) this.validator.pattern = { pattern: new RegExp(val), message: `${this.data.label}格式不匹配` }
      else this.validator.pattern = null

      // delete this.data.pattern
      this.generateRule()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/avue/small-component/custom.vue